'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventEmitter = require('../eventEmitter');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _transport = require('../../transport/transport.xhr');

var _transport2 = _interopRequireDefault(_transport);

var _sync = require('./sync.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CONNECTING = 0,
    CLOSED = 3,
    CLOSING = 2,
    OPEN = 1,
    INITIAL = -1;

var defaultOptions = {
    pollInterval: 100
};

var _class = function (_EventEmitter) {
    _inherits(_class, _EventEmitter);

    /**
     * @param {object} options
     * options.url - API URL
     * onOpen
     * onClose
     * onError - response protocol validation failed
     * onMessage
     */
    function _class() {
        var _ret;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

        _this.stream = null;
        _this.queue = [];
        _this.readyState = INITIAL;

        _this.options = Object.assign({}, defaultOptions, options);
        _this.storage = options.storage;
        _this.url = options.url;
        _this.parsers = options.parsers;

        if (typeof options.protocol !== 'undefined') {
            _this.protocol = options.protocol;
        }

        _this.Transport = options.transport || _transport2.default;

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
        key: 'isOpen',
        value: function isOpen() {
            return this.stream && this.readyState === OPEN;
        }
    }, {
        key: 'isConnecting',
        value: function isConnecting() {
            return this.readyState === CONNECTING;
        }
    }, {
        key: 'isClosed',
        value: function isClosed() {
            return this.readyState === CLOSED;
        }
    }, {
        key: 'isInitial',
        value: function isInitial() {
            return this.readyState === INITIAL;
        }
    }, {
        key: 'connect',
        value: function connect() {
            if (this.isInitial() || this.isClosed()) {
                this.readyState = CONNECTING;
                this._poll().then(this._handleStreamOpen.bind(this));
            }

            return this;
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.stream && typeof this.stream.close === 'function') {
                this.stream.close();
            }

            this._handleStreamClose();

            return this;
        }

        /**
         * @param {object} data
         * @param {object} options
         * @return {Promise}
         */

    }, {
        key: 'send',
        value: function send() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (this.isOpen()) {
                var transport = void 0,
                    queryOptions = void 0;

                queryOptions = Object.assign({}, this.options, {
                    method: 'post',
                    dataType: 'json',
                    contentType: 'application/json'
                }, options);

                transport = new this.Transport(this.url, queryOptions);

                if (queryOptions.contentType === 'application/json') {
                    data = JSON.stringify(data);
                    // alias for migration from jquery to axios
                    queryOptions.headers = queryOptions.headers || {};
                    queryOptions.headers['Content-Type'] = queryOptions.contentType;
                }

                if (queryOptions.dataType) {
                    // alias for migration from jquery to axios
                    queryOptions.responseType = queryOptions.dataType;
                }

                if (typeof transport.send === 'function') {
                    return transport.send(data);
                } else {
                    return Promise.reject('Pooling: send method is not defined. Check WebSocket transport API.');
                }
            } else {
                return this._addToQueue(data);
            }
        }
    }, {
        key: 'setURL',
        value: function setURL(url) {
            if (url) {
                this.url = url;
            }

            return this;
        }
    }, {
        key: '_handleStreamOpen',
        value: function _handleStreamOpen(stream) {
            if (this.isConnecting()) {
                this.readyState = OPEN;

                if (typeof this.options.onOpen === 'function') {
                    this.options.onOpen();
                }

                this._runQueue();
            }

            return Promise.resolve(stream);
        }
    }, {
        key: '_handleStreamClose',
        value: function _handleStreamClose() {
            if (this.isOpen()) {
                this.readyState = CLOSED;
                this._stopQueue();
                this._clearQueue();

                if (typeof this.options.onClose === 'function') {
                    this.options.onClose();
                }
            }
        }
    }, {
        key: '_nextPool',
        value: function _nextPool() {
            var _this2 = this;

            setTimeout(function () {
                if (_this2.isOpen()) {
                    _this2._poll();
                }
            }, this.options.pollInterval);

            return this;
        }
    }, {
        key: '_poll',
        value: function _poll() {
            var _this3 = this;

            if (!this.url) {
                return Promise.reject('Pooling: missed required "url" attribute.');
            } else {
                this.stream = new this.Transport(this.url, this.options);

                this.stream.get().then(
                // success
                this._handleStreamMessage.bind(this),
                // error, ignore errors
                function () {
                    return Promise.resolve();
                }).then(function () {
                    return _this3._nextPool();
                });

                return Promise.resolve(this.stream);
            }
        }
    }, {
        key: '_handleStreamMessage',
        value: function _handleStreamMessage(response) {
            var packet = {};

            if (typeof this.protocol === 'function') {
                // valid server response
                packet = this.protocol(response.data);
            } else {
                packet = {
                    status: _sync.responseState.SUCCESS,
                    data: response.data
                };
            }

            // response is invalid by protocol rules
            if (packet.status === _sync.responseState.ERROR) {
                if (typeof this.options.onError === 'function') {
                    this.options.onError(packet);
                }
            } else if (packet.status === _sync.responseState.SUCCESS) {
                if (typeof this.options.onMessage === 'function') {
                    this.options.onMessage(packet.data);
                }
            }

            return Promise.resolve(packet);
        }
    }, {
        key: '_clearQueue',
        value: function _clearQueue() {
            this.queue.length = 0;
        }
    }, {
        key: '_stopQueue',
        value: function _stopQueue() {
            return clearInterval(this._queueInterval);
        }
    }, {
        key: '_runQueue',
        value: function _runQueue() {
            var _this4 = this;

            this._stopQueue();

            this._queueInterval = setInterval(function () {
                if (_this4.isOpen() && _this4.queue.length) {
                    var item = _this4.queue.unshift();

                    if (typeof item.cb === 'function') {
                        item.cb();
                    }

                    if (typeof item.p === 'function') {
                        item.p();
                    }
                }
            }, 100);
        }
    }, {
        key: '_addToQueue',
        value: function _addToQueue(data) {
            var _this5 = this;

            return new Promise(function (resolve) {
                _this5.queue.push({
                    p: resolve,
                    cb: function cb() {
                        return _this5.send(data);
                    }
                });
            });
        }
    }]);

    return _class;
}(_eventEmitter2.default);

exports.default = _class;